module.exports = __webpack_public_path__ + "staticVue/img/logowhite.9aaf1575.png";